/**
 * 表单校验器集合
 * 功能：isExternal 与数字/大写/范围/邮箱等正则校验规则
 */
const isNumberReg = /^[0-9][0-9]*$/;
const isCapitalReg = /^[A-Z]+$/;
const isGreater0Less50Reg = /^[1-4][0-9]{0,1}|50$/
const isGreater0Less50RegZ = /^\d$|^([1-4]\d)$|50$/
const isGreater0RegZ = /^\d*$/
const isGreater0Less100Reg = /(^[0-9]{1}(\.\d{1,3})?$)|(^[1-9]\d{1}(\.\d{1,3})?$)|^100$/


/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
/** 校验只能输入数字 */
export const isNumber = (rule, value, callback) => {
  const reg = isNumberReg
  if (value != "") {
    if (!reg.test(value)) {
      callback(new Error('请输入数字'))
    } else {
      callback()
    }
  } else {
    callback()
  }

}
/** 
 * 只能是大写字母
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 */
export const isCapital = (rule, value, callback) => {
  const reg = isCapitalReg
  if (value != "") {
    if (!reg.test(value)) {
      callback(new Error('请输入大写字母'))
    } else {
      callback()
    }
  } else {
    callback()

  }
}
/** 
 * 只能输入>0 <50的数字
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 */
export const isGreater0Less50 = (rule, value, callback) => {
  const reg = isGreater0Less50Reg
  if (value != "") {
    if (!reg.test(value)) {
      callback(new Error('请输入>0且<50的数字'))
    } else {
      callback()
    }
  } else {
    callback()

  }
}

/** 
 * 只能输入>0 <50的正整数数字
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 */
export const isGreater0Less50Z = (rule, value, callback) => {
  const reg = isGreater0Less50RegZ
  if (value != "") {
    if (!reg.test(value)) {
      callback(new Error('请输入>0且<50的正整数'))
    } else {
      callback()
    }
  } else {
    callback()

  }
}
/**
 * 大于0的正整数
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 */
export const isGreater0Z = (rule, value, callback) => {
  const reg = isGreater0RegZ
  if (value != "") {
    if (!reg.test(value)) {
      callback(new Error('请输入≥0正整数'))
    } else {
      callback()
    }
  } else {
    callback()

  }
}
/**
 * 校验大于 0 且小于等于 100 的数字，保留到小数点后三位
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export const isGreater0Less100LaterThree = (rule, value, callback) => {
  const reg = isGreater0Less100Reg
  if (value != "") {
    if (!reg.test(value)) {
      callback(new Error('请输入>0,且≤100的数字,并保留到小数点后三位'))
    } else {
      callback()
    }
  } else {
    callback()

  }
}

/** 校验邮箱格式 */
export const isEmailReg = (rule, value, callback) => {
  const reg = /^[\w\-\.]+@[a-z0-9]+(\-[a-z0-9]+)?(\.[a-z0-9]+(\-[a-z0-9]+)?)*\.[a-z]{2,4}$/i
  //  /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]$/
  if (value != "") {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的邮箱格式！'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}